import transport from '../utils/axios';

/**
 * Public storefront settings — a stable subset of `/admin/settings` that
 * the storefront needs without authentication. Today it surfaces:
 *
 *   { checkout: { allow_guest: bool, min_order_total: number } }
 *
 * If the backend hasn't shipped this endpoint yet, the call returns
 * an empty payload and the UI gracefully assumes guest checkout is
 * disabled. See ROADMAP_STOREFRONT §3.2 for the spec.
 */
export const getStorefrontSettings = async () => {
    try {
        const { data } = await transport.get('/storefront/settings');
        return data?.data || {};
    } catch (err) {
        // 404 / 5xx → safe defaults so the UI doesn't crash. Worst case:
        // guest checkout stays disabled until the backend ships.
        return {};
    }
};
